export const USER_EXPAND = 'USER_EXPAND';
export const SYSTEM_EXPAND = 'SYSTEM_EXPAND';
export const USER_COLLAPSE = 'USER_COLLAPSE';
export const SYSTEM_COLLAPSE = 'SYSTEM_COLLAPSE';
export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE';
